var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',_vm._g({staticClass:"d-flex align-center c360-text-badge c360-gray--text px-2 my-3 c360-navigation-drawer-expand-btn",attrs:{"color":"transparent","text":""}},_vm.$listeners),[_c('c360-icon',{staticClass:"mr-3",attrs:{"icon":_vm.icon}}),(!_vm.isActive)?_c('span',[_vm._v("HIDE SIDEBAR")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }